import axios from 'axios';

// API Basis-URL konfigurieren - automatische Erkennung
const getApiBaseUrl = () => {
  // If environment variable is set, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Auto-detect based on current hostname and port
  const hostname = window.location.hostname;
  const port = window.location.port;
  
  // Development: localhost with port 3001 → use backend port 8010
  if (hostname === 'localhost' && port === '3001') {
    return 'http://localhost:8010';
  }
  
  // Production: any domain without specific port → use relative URLs
  return '';
};

const API_BASE_URL = getApiBaseUrl();

// Axios Instanz mit Basis-Konfiguration
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor für JWT und Debugging
api.interceptors.request.use(
  (config) => {
    console.log('API Request:', config.method?.toUpperCase(), config.url);
    
    // Add JWT token to all admin API requests
    const token = localStorage.getItem('admin_token');
    if (token && config.url && config.url.includes('/api/admin/')) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Response Interceptor für Fehlerbehandlung und JWT-Expiry
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('API Response Error:', error.response?.status, error.response?.data);
    
    // Handle JWT token expiry - redirect to login
    if (error.response?.status === 401 && error.config?.url?.includes('/api/admin/')) {
      console.log('JWT token expired, removing token and redirecting to login');
      localStorage.removeItem('admin_token');
      // Force page reload to trigger authentication check
      window.location.reload();
    }
    
    return Promise.reject(error);
  }
);

export default api; 